
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M351 106.5V142h11V82h139v177h-60.8l-.4-25.8c-.3-25-.4-25.8-2.8-30.5-4.6-9.2-12.4-14-22.5-14-5.4 0-9.4 1.3-38.5 13.1-70.8 28.5-67.5 27-71.8 33.3-3.2 4.7-2.7 11.8 1.3 15.9 3.6 3.7 10.2 5.4 15.7 3.9 2.3-.6 18.4-6.8 36-13.9l31.8-12.9V259h-27v-7h-11v181h161V71H351v35.5zm41.5 13.8c-10 4.9-15.7 14.2-15.7 25.4 0 24.7 30.2 36.6 47.5 18.7 10.3-10.6 10-28.1-.7-38.7-5-5.1-10.1-7.1-18.6-7.5-6.3-.2-8.3.1-12.5 2.1zM81.1 197.6C68 201.1 57 211.7 53 224.7c-1.8 5.9-2 9.3-2 34.8 0 26.6-.4 31.4-2.7 29.1-.3-.3-1.2-5.6-1.9-11.8l-1.3-11.6c-.1-.1-10.2-.2-22.6-.2H0v23.7l14.3.7c7.8.3 17.9.9 22.5 1.3l8.2.6-4.5 4.8c-8.5 9.1-8.6 9.8-8.3 45.4l.3 31 2.7 4.6c1.5 2.6 5.1 6.8 8 9.4l5.3 4.7.5 18.3c.5 17.7.6 18.2 3.1 21.6 4.3 5.6 12 9.2 21 9.7 13.9.8 24.8-3.8 28.8-12.2 1.8-3.7 2.1-6.1 2.1-18.4V396h108v12.6c0 16.5 1 20.4 6.8 25.4 12.9 11.4 39.7 8.4 46.8-5.2 1-2 1.4-7 1.4-19.1v-16.3l3.5-1.7c4.9-2.4 12.2-9.3 15.3-14.6l2.7-4.6.3-30.3c.4-35.3.1-36.9-7.9-45.6l-4.9-5.3 8.3-.7 22.5-1.2 14.2-.7V265h-22.5l-22.6.2c0 .2-.6 5.4-1.3 11.6s-1.6 11.5-1.9 11.8c-2.3 2.3-2.7-2.5-2.7-29.1 0-24.6-.2-29.1-1.8-34.2-4.4-14-14.9-24.2-28.8-27.8-8.5-2.2-150.1-2.1-158.3.1zm157.9 17c5.4 2.6 10.3 7.5 12.7 12.9 1.5 3.4 1.8 7.7 2.1 30.2l.3 26.3H67v-24.3c0-27.8.8-32.2 6.7-38.8 4.2-4.6 7.7-6.7 13.6-7.9 2.3-.4 36.4-.7 75.7-.7 70.6.2 71.6.2 76 2.3zM108.8 341.7l-.3 17.8-24.7.3-24.8.2v-36h50l-.2 17.7zm160.2.3v18h-50v-36h50v18zm-63 7.5v5.5h-85v-11h85v5.5zm-86.3 25.7c2.5 2.3 2.9 4.8 1.2 7.9-2.4 4.6-10 4-11.7-.9-2.4-7 5.1-12 10.5-7zm97.1-.6c2.9 2 3 7.4.2 9.9-4.2 3.8-11 .9-11-4.7s6-8.6 10.8-5.2z"}})])
          )
        }
      }
    